import { computed, getCurrentInstance } from "vue";
import uuidv1 from "uuid/v1";
import useAuthentication from "@/composition/useAuthentication";
import store from "@/store";
import state from "./shareSearchState";
import useMatomoEvent from "./useMatomoEvent";

export default () => {
  const instance = getCurrentInstance();
  const profile = store.getters["user/getProfile"];
  const { validateAndRetrieveToken } = useAuthentication();
  const currentPath = computed(() => instance.proxy.$route.path);

  const saveSharedFilter = ({ name, filterRules }, inLeftNavBar = false) => {
    const newSharedFilter = {
      id: uuidv1(),
      color: "#ff0000",
      name,
      owner: profile.sub,
      ownerDpaIdAccountId: profile.account_id,
      description: "",
      filterRules,
      isVisible: true,
      isPublic: false,
      isShared: true
    };
    store.dispatch("filters/saveFilter", {
      filter: newSharedFilter,
      authJWT: validateAndRetrieveToken()
    });
    state.url = `${window.location.protocol}//${window.location.host}/app${currentPath.value}?sharedSearchId=${newSharedFilter.id}`;
    state.title = newSharedFilter.name;
    state.sharedFilterId = newSharedFilter.id;
    state.visible = true;

    const matomoEvent = inLeftNavBar
      ? {
          category: "Left Navigation Bar",
          action: "Left Navigation Bar Suche teilen",
          name: 'Click "Suche teilen" in Left Navigation Bar'
        }
      : {
          category: "Search Results Suche teilen",
          action: 'Search Results "Suche teilen"',
          name: 'Click "Suche teilen" in Search Results'
        };
    useMatomoEvent(matomoEvent);
  };

  const showDialog = () => {
    state.visible = true;
  };

  const hideDialog = () => {
    state.visible = false;
  };

  return {
    saveSharedFilter,
    showDialog,
    hideDialog
  };
};
